import { eventProperties } from './vars'
import { track } from '@amplitude/analytics-browser'

export const trackCodeSendAgain = () =>
  track({
    event_type: 'code_send_again',
    event_properties: eventProperties
  }).promise
